import React from 'react';

import ShowChartRoundedIcon from '@mui/icons-material/ShowChartRounded';

import LineChart from '../../components/lineChart';
import {
    formatInteger,
    formatPercentage
} from '../../utils/numberUtils';
import { CHART_METRICS } from './conversaoLPsData';

const MAX_X_TICKS = 10;

const ConversaoLPsTrend = ({ eyebrow, metric, onMetricChange, rows, seriesList }) => {
    const isSingleSeries = seriesList.length === 1;
    const metricLabel = CHART_METRICS.find((option) => option.value === metric).label;
    const formatValue = (row, keys) => {
        if (metric === 'conversao') {
            return row[keys.hasVisits] ? `${formatPercentage(row[keys.conversao])}%` : 'sem tráfego';
        }

        return formatInteger(row[keys[metric]]);
    };
    const series = seriesList.map((serie) => ({
        key: serie.keys[metric],
        label: serie.label,
        color: serie.color,
        tooltipValue: (row) => (isSingleSeries ? `${formatValue(row, serie.keys)} ${metric === 'conversao' ? '' : metricLabel.toLowerCase()}`.trim() : `${serie.label}: ${formatValue(row, serie.keys)}`),
        peakText: (peak) => `${isSingleSeries ? 'Pico' : serie.label}: ${formatValue(peak, serie.keys)} em ${peak.shortLabel}`
    }));

    return (
        <div className='crm-lp-trend'>
            <div className='crm-lp-trend-toolbar'>
                <div className='crm-lp-toggle' role='group' aria-label='Métrica do gráfico'>
                    {CHART_METRICS.map((option) => (
                        <button
                            type='button'
                            key={option.value}
                            className={metric === option.value ? 'is-active' : ''}
                            aria-pressed={metric === option.value}
                            onClick={() => onMetricChange(option.value)}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
                {metric === 'conversao' && (
                    <span className='crm-lp-hint'>Leads ÷ visitas somados do início do período até o dia.</span>
                )}
            </div>

            <LineChart
                ariaLabel={`${metricLabel} por dia`}
                eyebrow={eyebrow}
                icon={ShowChartRoundedIcon}
                maxXTicks={MAX_X_TICKS}
                pointAriaLabel={(point) => `${point.label}: ${series.map((serie) => serie.tooltipValue(point)).join(', ')}`}
                pointKey={(point) => point.data}
                rows={rows}
                series={series}
                title={`${metricLabel} por dia`}
                xTickLabel={(point) => point.shortLabel}
                yTickLabel={metric === 'conversao' ? (tick) => `${formatPercentage(tick)}%` : undefined}
            />
        </div>
    );
};

export default ConversaoLPsTrend;
